/**
 * 待播放的当前帧数据
 *  ws 的链接问题：
 *  1. 每个车启用一个ws链接；并返回该车的可用数据的时间段，渲染成可选项；
 *  2. 根据不同的时间段，发起ws message，获取对应的数据；
 */
import { defineStore } from 'pinia'
import { ref, shallowRef } from "vue";
import { getCacheData, saveCacheData, clearCacheData, saveChartData, getCacheData_Map } from '@/utils/dataCache'
import { useStore } from '@/store';
import { downLoadData, params } from '@/utils/wsDataManager';
import { getVehiclePlayList } from '@/service/index'
import { useMetaDataStore } from "@/store/metaDataStore";
import { getQueryVariable } from '@/utils/utils';
export const useFrameDataStore = defineStore('frameDataStore', () => {
    const store = useStore();
    let wsData = null;//当前的ws，映射一个vehicle;
    const dataListStore = shallowRef([])

    let currentData = ref({});
    let currentData_map = ref(null);;
    let currentData_map_reflesh = ref(0);
    let currentTime = ref(0);
    let currentStep = 10;//起始点推前10秒;
    let currentVehicleId = ref("");//选择的哪个车 id zl00094
    let currentMissingTimestampList = ref([]);//缺失数据的时间List
    let currentTimeRange = ref({
        start: 0,
        end: 0
    }); // 选择的时间段

    let catch_count = 0;
    let catch_time_end_pre = ref(0);//缓存的最新时间前一段
    let catch_time_end_next = ref(0);//缓存的最新时间后一段
    let catch_time_list = ref([]);//缓存的最新时间后一段

    let timer_play = 0;

    let progress_status = ref(0);//0 表示播放 ;1 表示 暂停

    let queryStartTs = 0;// 表示是否跳转链接中 有当前时间；
    let queryStartTsMark = 0;//标识跳转时间的mark
    let queryStartTsForCache = 0;//标识跳转时间的Cache
    let queryStartTsForCacheTimeArr: any = [];//存储要下载的时间区间List;分块下载。

    let play_speet = ref(1);//播放的倍速；

    let play_next_auto = localStorage.getItem('play_next_auto') || 0;//是否自动播放下一个包
    let play_next_auto_ST_time = ref(0);//自动播放下一个包的开始时间

    let flag_framedata = 0;//标记是否是double转int

    let metaDataStore = useMetaDataStore()

    let wait_datadownload = false;

    /**
     * 设置当前播放进度的时间戳；
     * @param time 
     */
    function setCurrentTime(time: number) {
        currentTime.value = time;
    }
    /**
     * 指定当前车辆
     * @param data 
     */
    async function setCurrentVehicleId(data: string) {
        currentVehicleId.value = data;
        // URL 上的 ts 是秒级时间戳，页面希望直接跳转到这个播放时间点。
        const queryStartTs = Math.floor(Number(getQueryVariable('ts') || 0));

        // 先按原有逻辑执行一次默认查询。
        // 不带时间范围时，后端通常返回默认窗口内的播放片段
        const res = await getVehiclePlayList(data);
        metaDataStore.setPlaylist(res.data);

        // 普通进入页面时 URL 不带 ts，此时只展示默认查询结果即可，不需要补查。
        if (!queryStartTs) return;

        const found = res.data.find(
            // 如果默认查询结果中已经存在覆盖 ts 的片段，说明可以直接使用当前列表
            (item) => queryStartTs >= item.start && queryStartTs <= item.end,
        );
        if (found) return;

        // 到这有三种可能
        // 1. URL 明确指定了 ts
        // 2. 默认查询结果里没有命中该 ts
        // 3. 可能是默认返回窗口没有覆盖这个时间，也可能首查直接返回空数组
        // 因此必须记录这次跳转时间，并基于 ts 做一次补查。
        setQueryStartTs(queryStartTs);

        // 两种情况来确定补查范围：
        // 1. 首查有数据：把 ts 与首查结果的整体时间边界合并
        // 2. 首查没数据：直接以 ts 为中心向前或者向后扩一个固定窗口，避免因为空数组
        const starts = res.data.map((item) => item.start);
        const ends = res.data.map((item) => item.end);
        const rangeStart = starts.length
            ? Math.min(queryStartTs, Math.min(...starts))
            : queryStartTs - 86400;
        const rangeEnd = ends.length
            ? Math.max(queryStartTs, Math.max(...ends))
            : queryStartTs + 86400;

        const res2 = await getVehiclePlayList(
            data,

            Math.max(rangeStart - 86400, 0) * 1000,
            rangeEnd * 1000,
        );

        // 补查后如果仍然没有数据，则保持当前默认结果，由页面展示无可播放数据
        if (res2.data.length === 0) return;

        // 补查成功后，用更完整的结果覆盖默认列表
        metaDataStore.setPlaylist(res2.data);
    }

    function compareTimestampWithRange(timestamp: any, startTime: any, endTime: any) {
        const dateFromTimestamp = new Date(timestamp * 1000);
        // 将时间字符串转换为Date对象
        const startDate = new Date(startTime);
        const endDate = new Date(endTime);

        // 检查时间是否在范围内
        const isInRange = dateFromTimestamp >= startDate && dateFromTimestamp <= endDate;
        return isInRange 
    }


    /**
    * 指定当前车辆和时间段
    * @param data 
    */
    function setCurrentVehicleIdAndTime(data: string, dataTime: Array<number>) {
        currentVehicleId.value = data;
        currentTimeRange.value.start = parseInt(String(dataTime[0]))
        currentTimeRange.value.end = parseInt(String(dataTime[1]))
        getVehiclePlayList(data, currentTimeRange.value.start, currentTimeRange.value.end).then(res => {
            metaDataStore.setPlaylist(res.data);
        })
    }


    //#region 播放控制
    /**
     * 暂停、播放事件。1=暂停 0=播放
     * @param status 
     */
    function setProgress_status(status: number) {
        progress_status.value = status;
        if (status == 0) {
            playData(currentTime.value);
        } else {
            clearTimeout(timer_play)
        }
    }

    /**
     * 选中的要播放的时间段的起止时间戳，也就是切包。
     */
    let currentTimeInterval = ref({
        startTs: 0,
        endTs: 0
    })
    /**
    * 设置要播放的时间区间，起止点  切包
    * @param data 
    */
    async function setCurrentTimeInterval(startTs: number, endTs: number, missingTimestampList: any, origin: any) {
        //0. 暂停        
        setProgress_status(1);
        //1. 重置时间区间、播放轴    
        store.commit('setLoadingText', { text: '请稍后,获取所选时间段数据中...' });
        currentTimeInterval.value = {
            startTs,
            endTs
        }
        //2. 重置播放进度 值；       

        //3. 缓存数量
        catch_count = 0;

        //4. 缺失时间数据重置
        currentMissingTimestampList.value = missingTimestampList || []

        //5. 清理缓存数据
        dataListStore.value = [];
        clearCacheData();
        catch_time_list.value = [];
        //6。开始下载时间
        if ((queryStartTsForCache - currentStep) * 1000 - startTs > 0) {
            let midTs = (queryStartTsForCache - currentStep) * 1000;
            currentTime.value = midTs;
        } else {
            currentTime.value = startTs;
        }
        //下载数据
        //wswsws
        let missList = await downLoadData(currentVehicleId.value, startTs, endTs, origin, currentTime.value)
        currentMissingTimestampList.value = missList || []
        queryStartTsForCache = 0;
        catch_time_end_pre.value = 0;
        catch_time_end_next.value = 0;
        wait_datadownload = true;
    }


    function startPlay() {
        if (wait_datadownload) {
            wait_datadownload = false;
            store.commit('setLoadingText', { text: '' });
            setProgress_status(0)
            playData(currentTime.value);
        }
    }

    /**
     * 
     * @param type 播放一帧数据; type=1 next；； type=-1 prev
     */
    function playFrameOne(type: number) {
        setProgress_status(1);
        let timeStep = type * 200;
        let newTime = currentTime.value + timeStep;
        
        if (newTime <= currentTimeInterval.value.endTs && newTime >= currentTimeInterval.value.startTs) {
            //时间在区间内 
            currentTime.value = newTime;
            currentData.value = getCacheData(newTime, 200)
        }
    }
    //#endregion



    //#region 私有方法
    /**
     * 开启播放数据 定时器
     * @param startTs 
     */
    function playData(startTs: number) {
        currentTime.value = startTs;
        if (currentTime.value <= currentTimeInterval.value.endTs && progress_status.value == 0 && catch_count > 10) {
            let data = getCacheData(currentTime.value, 200 * play_speet.value)

            if (is_downloading(currentTime.value)) {
                store.commit('setLoadingText', { text: '请稍后,数据下载中', is_hold: true });
            } else {
                store.commit('setLoadingText', { text: '' });
                currentData.value = data
                let data_map = getCacheData_Map(currentTime.value, 200 * play_speet.value)
                if (data_map) {
                    currentData_map.value = data_map;
                    currentData_map_reflesh.value = currentTime.value;
                }
                currentTime.value += 200 * play_speet.value;
                if (currentTime.value >= currentTimeInterval.value.endTs) {
                    //播放完毕
                    setProgress_status(1);
                    play_next_auto_ST_time.value = currentTime.value + 10000;
                }
            }
        }
        if (timer_play) clearTimeout(timer_play);
        timer_play = setTimeout(() => {
            playData(currentTime.value)
        }, 200)
    }

    //#endregion

    //#region  ws、缓存数据 的操作。
    /**
     * 从ws中，缓存数据
     * @param params 
     */
    function saveFrameData(data: any) {
        if (data.timestamp >= currentTimeInterval.value.startTs && data.timestamp <= currentTimeInterval.value.endTs) {
            const res = saveChartData(data);
            if (res) {
                dataListStore.value.push(res);
            }
            saveCacheData(data);
            setCatchNumber(data)
            catch_time_list.value.push(data.timestamp);
            flag_framedata = data.flag_framedata;

        } else {
            //数据分段有问题
        }
    }

    /**
     * 设置已经缓存的数据帧总数
     * @param params 
     */
    function setCatchNumber(data: any) {
        catch_count++;
        // if (catch_count == 10) {
        //     //开始播放，
        //     store.commit('setLoadingText', '');
        //     // setProgress_status(0)
        // }
    }
    //#endregion

    //#region 初始化时间
    /**
     * 
     * @param params 
     */
    function getQueryStartTs() {
        const cache = queryStartTs;
        const urlTs = getQueryVariable('ts');
        queryStartTs = urlTs ? Math.floor(Number(urlTs)) : 0;
        return cache;
    }
    function getQueryStartTsMark() {
        let cache = queryStartTsMark;
        queryStartTsMark = 0;
        return cache;
    }
    /**
    * 
    * @param params 
    */
    function setQueryStartTs(value: number) {
        const value_floor = Math.floor(Number(value || 0));
        queryStartTs = value_floor;
        queryStartTsMark = value_floor;
        queryStartTsForCache = value_floor;
    }

    function is_downloading(currentTime: number) {
        let stepInfo = params.stepList.find(e => e.start <= currentTime && e.end >= currentTime);
        if (stepInfo?.state === 0 || stepInfo?.state === 1) {
            return true
        } else {
            return false;
        }
    }

    interface GetValueParams {
        parentObj: any;
        attributeName: string;
        attributeName_new: string;
        scale: number;
    }

    //#endregion

    return {
        currentData, currentTime, currentTimeInterval, currentMissingTimestampList, catch_time_end_next, catch_time_end_pre,
        progress_status,
        play_speet,
        currentVehicleId,
        currentTimeRange,
        play_next_auto_ST_time,
        play_next_auto,
        catch_time_list,
        currentStep,
        dataListStore,
        currentData_map_reflesh,
        currentData_map,
        setQueryStartTs, getQueryStartTs,
        setCurrentTime, setCurrentVehicleId, setCurrentTimeInterval, saveFrameData, setCurrentVehicleIdAndTime,
        setProgress_status,
        playFrameOne,
        getQueryStartTsMark,
        startPlay
    }
})